import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Notifications } from './components/Notifications';
import Ancoras from './pages/Anchors/All';
import AncorasEdit from './pages/Anchors/Anchor/Edit';
import AncorasRegister from './pages/Anchors/Anchor/Register';
import AncorasVisualize from './pages/Anchors/Anchor/Visualize';
import AncorasLojasContactsEdit from './pages/Anchors/Contacts/Edit';
import AncorasLojasContactsRegister from './pages/Anchors/Contacts/Register';
import AncorasLojasContactsVisualize from './pages/Anchors/Contacts/Visualize';
import AncorasLojasEdit from './pages/Anchors/Stores/Edit';
import AncorasLojasRegister from './pages/Anchors/Stores/Register';
import AncorasLojasVisualize from './pages/Anchors/Stores/Visualize';
import AncorasLojasCodesEdit from './pages/Anchors/StoresCodes/Edit';
import AncorasLojasCodesRegister from './pages/Anchors/StoresCodes/Register';
import AncorasLojasCodesVisualize from './pages/Anchors/StoresCodes/Visualize';
import AncorasLojasTaxasFaixasEdit from './pages/Anchors/TaxasFaixas/Edit';
import AncorasLojasTaxasFaixasRegister from './pages/Anchors/TaxasFaixas/Register';
import AncorasLojasTaxasFaixasVisualize from './pages/Anchors/TaxasFaixas/Visualize';
import AnticipationOperation from './pages/AnticipationOperation';
import Login from './pages/Auth/Login';
import { RequiredChangePassword } from './pages/Auth/RequiredChangePassword';
import { ChangePassword } from './pages/ChangePassword';
import Contributors from './pages/Collaborator/Contributors';
import EditCollaborator from './pages/Collaborator/Edit';
import RegisterCollaborator from './pages/Collaborator/Register';
import VisualizeCollaborator from './pages/Collaborator/Visualize';
import { ConclusionOperation } from './pages/ConclusionOperation';
import Home from './pages/Home';
import { Providers } from './pages/Providers';
import { Provider } from './pages/Providers/Provider/';
import { AnchorProviderRegister } from './pages/Providers/Provider/registers/AnchorRegister';
import { AnotationProviderRegister } from './pages/Providers/Provider/registers/AnotationRegister';
import { BankRegister } from './pages/Providers/Provider/registers/BankRegister';
import { ContactGroupRegister } from './pages/Providers/Provider/registers/ContactGroupRegister';
import { ExceptionRegister } from './pages/Providers/Provider/registers/ExceptionRegister';
import { ProvidersGroup } from './pages/ProvidersGroup';
import { GroupProviderRegister } from './pages/ProvidersGroup/register';
import { RedirectConclusion } from './pages/RedirectConclusion';
import { Registers } from './pages/Registers';
import { Reports } from './pages/Reports';
import { PeriodReport } from './pages/Reports/PeriodReport';
import { ClosingMonthReport } from './pages/Reports/ClosingMonthReport';
import { ProductionReport } from './pages/Reports/ProductionReport';
import { PaimentBillsReport } from './pages/Reports/PaimentBillsReport';
import { DailyProductionReport } from './pages/Reports/DailyProductionReport';
import { ComparativeReport } from './pages/Reports/ComparativeReport';
import { AnchorAnticipationReport } from './pages/Reports/AnchorAnticipationReport';
import { DynamicReport } from './pages/Reports/DynamicReport';
import { AccumulatedReport } from './pages/Reports/AccumulatedReport';
import { TargetReport } from './pages/Reports/TargetReport';
import TimeTable from './pages/TimeTable';
import { isAuthenticated } from './services/auth';
import { TimeCard } from './pages/TimeCard';
import { TimeCardRegister } from './pages/TimeCard/register';
import { TimeCardReport } from './pages/Reports/TimeCardReport';
import { Platforms } from './pages/Platforms';
import { PlatformRegister } from './pages/Platforms/register';
import { ConclusionInterestEmails } from './pages/ConclusionInterestEmails'
import {EthicsCode} from './pages/EthicsCode'
import OperationMenu from "./pages/OperationMenu"
import { ContactAssGroup } from './pages/Providers/Provider/components/ContactAssGroup';
import { ContactGroupAssRegister } from './pages/Providers/Provider/registers/ContactGroupAssRegister';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <>
          <Notifications />
          <Component {...props} />
        </>
      ) : (
        <Redirect to={{ pathname: '/app', state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <div style={{ overflowX: 'hidden' }}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Switch>
        <Route exact path="/">
          <Redirect to="/app" />
        </Route>
        <Route exact path="/app/conclusao-operacao" component={() => <RedirectConclusion />} />
        <Route exact path="/app/conclusao" component={() => <ConclusionOperation />} />
        <Route exact path="/app/conclusao-emailsInteresse" component={() => <ConclusionInterestEmails />} />
        <Route exact path="/app" component={() => <Login />} />
        <Route exact path="/app/login" component={() => <Login />} />
        <Route
          exact
          path="/app/troca-senha-obrigatoria"
          component={() => <RequiredChangePassword />}
        />

        <PrivateRoute exact path="/app/codigo-etica" component={() => <EthicsCode />} />
        
        <PrivateRoute exact path="/app/home" component={() => <Home />} />
        <PrivateRoute exact path="/app/colaboradores" component={() => <Contributors />} />
        <PrivateRoute
          exact
          path="/app/visualizar-colaborador/:id"
          component={(routerProps) => <VisualizeCollaborator id={routerProps.match.params.id} />}
        />
        <PrivateRoute
          exact
          path="/app/editar-colaborador/:id"
          component={(routerProps) => <EditCollaborator id={routerProps.match.params.id} />}
        />
        <PrivateRoute exact path="/app/alterar-senha" component={() => <ChangePassword />} />
        <PrivateRoute exact path="/app/registrar-ponto" component={() => <TimeTable />} />
        <PrivateRoute exact path="/app/registrar-ponto/:warn" component={() => <TimeTable />} />
        <PrivateRoute
          exact
          path="/app/cadastrar-colaborador"
          component={() => <RegisterCollaborator />}
        />

        <PrivateRoute exact path="/app/ancoras" component={() => <Ancoras />} />
        <PrivateRoute exact path="/app/ancoras/cadastrar" component={() => <AncorasRegister />} />
        <PrivateRoute
          exact
          path="/app/editar-ancora/:id"
          component={(routerProps) => <AncorasEdit id={routerProps.match.params.id} />}
        />
        <PrivateRoute
          exact
          path="/app/visualizar-ancora/:id"
          component={(routerProps) => <AncorasVisualize id={routerProps.match.params.id} />}
        />

        <PrivateRoute
          exact
          path="/app/ancoras-lojas/:ancoraid/cadastrar"
          component={(routerProps) => (
            <AncorasLojasRegister ancoraid={routerProps.match.params.ancoraid} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-lojas/editar/:id"
          component={(routerProps) => <AncorasLojasEdit id={routerProps.match.params.id} />}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-lojas/visualizar/:id"
          component={(routerProps) => <AncorasLojasVisualize id={routerProps.match.params.id} />}
        />

        <PrivateRoute
          exact
          path="/app/ancoras-lojas-codigos/:ancoralojaid/cadastrar"
          component={(routerProps) => (
            <AncorasLojasCodesRegister ancoralojaid={routerProps.match.params.ancoralojaid} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-lojas-codigos/editar/:id"
          component={(routerProps) => <AncorasLojasCodesEdit id={routerProps.match.params.id} />}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-lojas-codigos/visualizar/:id"
          component={(routerProps) => (
            <AncorasLojasCodesVisualize id={routerProps.match.params.id} />
          )}
        />

        <PrivateRoute
          exact
          path="/app/ancoras-contatos/:ancoraid/cadastrar"
          component={(routerProps) => (
            <AncorasLojasContactsRegister ancoraid={routerProps.match.params.ancoraid} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-contatos/editar/:id"
          component={(routerProps) => <AncorasLojasContactsEdit id={routerProps.match.params.id} />}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-contatos/visualizar/:id"
          component={(routerProps) => (
            <AncorasLojasContactsVisualize id={routerProps.match.params.id} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-taxas-faixas/:ancoraid/cadastrar"
          component={(routerProps) => (
            <AncorasLojasTaxasFaixasRegister ancoraid={routerProps.match.params.ancoraid} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-taxas-faixas/editar/:id"
          component={(routerProps) => (
            <AncorasLojasTaxasFaixasEdit id={routerProps.match.params.id} />
          )}
        />
        <PrivateRoute
          exact
          path="/app/ancoras-taxas-faixas/visualizar/:id"
          component={(routerProps) => (
            <AncorasLojasTaxasFaixasVisualize id={routerProps.match.params.id} />
          )}
        />

        <PrivateRoute exact path="/app/grupo-fornecedores" component={() => <ProvidersGroup />} />
        <PrivateRoute
          exact
          path="/app/grupo-fornecedor/cadastrar"
          component={() => <GroupProviderRegister />}
        />
        <PrivateRoute
          exact
          path="/app/grupo-fornecedor/:id"
          component={() => <GroupProviderRegister />}
        />

        <PrivateRoute
          exact
          path="/app/grupo-fornecedor/:id/editar"
          component={() => <GroupProviderRegister />}
        />

        <PrivateRoute exact path="/app/fornecedores" component={() => <Providers />} />
        <PrivateRoute exact path="/app/fornecedor/cadastrar" component={() => <Provider />} />
        <PrivateRoute exact path="/app/fornecedor/:id" component={() => <Provider />} />
        <PrivateRoute exact path="/app/fornecedor/:id/editar" component={() => <Provider />} />

        <PrivateRoute exact path="/app/cadastros" component={() => <Registers />} />

        <PrivateRoute exact path="/app/cartoes-ponto" component={() => <TimeCard />} />
        <PrivateRoute
          exact
          path="/app/cartoes-ponto/cadastrar"
          component={() => <TimeCardRegister />}
        />
        <PrivateRoute exact path="/app/cartoes-ponto/:id" component={() => <TimeCardRegister />} />
        <PrivateRoute
          exact
          path="/app/cartoes-ponto/:id/editar"
          component={() => <TimeCardRegister />}
        />
        <PrivateRoute
          exact
          path="/app/cartoes-ponto/:id/visualizar"
          component={() => <TimeCardRegister />}
        />

        <PrivateRoute
          exact
          path="/app/plataformas"
          component={() => <Platforms />}
        />

        <PrivateRoute
          exact
          path="/app/plataforma/cadastrar"
          component={() => <PlatformRegister />}
        />

        <PrivateRoute
          exact
          path="/app/plataforma/:id/visualizar"
          component={() => <PlatformRegister />}
        />

        <PrivateRoute
          exact
          path="/app/plataforma/:id"
          component={() => <PlatformRegister />}
        />

        <PrivateRoute
          exact
          path="/app/plataforma/:id/editar"
          component={() => <PlatformRegister />}
        />

        <PrivateRoute exact path="/app/relatorios" component={() => <Reports />} />
        <PrivateRoute exact path="/app/relatorios/:periodo" component={() => <PeriodReport />} />
        <PrivateRoute
          exact
          path="/app/relatorios/:periodo/:anchorId"
          component={() => <PeriodReport />}
        />
        <PrivateRoute
          exact
          path="/app/relatorios/:periodo/:anchorId/:date"
          component={() => <PeriodReport />}
        />
        <PrivateRoute exact path="/app/relatorio/producao" component={() => <ProductionReport />} />
        <PrivateRoute exact path="/app/relatorio/fechamentoMensal" component={() => <ClosingMonthReport />} />
        <PrivateRoute
          exact
          path="/app/relatorio/contasAPagar"
          component={() => <PaimentBillsReport />}
        />
        <PrivateRoute
          exact
          path="/app/relatorio/producao/diaria"
          component={() => <DailyProductionReport />}
        />
        <PrivateRoute exact path="/app/relatorio/metas" component={() => <TargetReport />} />
        <PrivateRoute exact path="/app/relatorio/timecard" component={() => <TimeCardReport />} />

        <PrivateRoute exact path='/app/relatorio/comparativo' component={() => <ComparativeReport />} />

        <PrivateRoute exact path='/app/relatorio/ancoraAntecipacoes' component={() => <AnchorAnticipationReport />} />

        <PrivateRoute exact path='/app/relatorio/dinamicos' component={() => <DynamicReport />} />
        <PrivateRoute exact path='/app/relatorio/dinamicos/:id' component={() => <DynamicReport />} />

        <PrivateRoute exact path='/app/relatorio/acumuladoRede' component={() => <AccumulatedReport />} />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-ancora"
          component={() => <AnchorProviderRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/ancora/:idAncora"
          component={() => <AnchorProviderRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/ancora/:idAncora/editar"
          component={() => <AnchorProviderRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-anotacao"
          component={() => <AnotationProviderRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/anotacao/:idAnotacao"
          component={() => <AnotationProviderRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/anotacao/:idAnotacao/editar"
          component={() => <AnotationProviderRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-excecao"
          component={() => <ExceptionRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/excecao/:idExcecao"
          component={() => <ExceptionRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/excecao/:idExcecao/editar"
          component={() => <ExceptionRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-conta-bancaria"
          component={() => <BankRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/conta-bancaria/:idContaBancaria"
          component={() => <BankRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/conta-bancaria/:idContaBancaria/editar"
          component={() => <BankRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-grupo-contato"
          component={() => <ContactGroupRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/grupo-contato/:idGrupoContato"
          component={() => <ContactGroupRegister />}
        />
        <PrivateRoute
          exact
          path="/app/fornecedor/:id/grupo-contato/:idGrupoContato/editar"
          component={() => <ContactGroupRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/cadastrar-grupo-contato-ass"
          component={() => <ContactGroupAssRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/grupo-contato-ass/:idGrupoContatoAss"
          component={() => <ContactGroupAssRegister />}
        />

        <PrivateRoute
          exact
          path="/app/fornecedor/:id/grupo-contato-ass/:idGrupoContatoAss/editar"
          component={() => <ContactGroupAssRegister />}
        />

        <PrivateRoute
          exact
          path="/app/operacao-antecipacao"
          component={() => <AnticipationOperation />}
        />

        <PrivateRoute
          exact
          path="/app/operacao-menu"
          component={() => <OperationMenu />}
        />



        {/* <Route path="*" component={() => <Login />} /> */}
      </Switch>
    </div>
  </BrowserRouter>
);

export default Routes;
